export default {"src":"/_next/static/media/Go-live-fast.df81cb9d.svg","height":1600,"width":1600};